export const currencyMutationFrag = `
    id
`;

export const currencyFrag = `
    id
    name
    code
`;
